import React, { FC, ReactNode } from 'react';
import { HeadingTags } from './typography.types';
import classNames from 'classnames';

import styles from './typography.module.scss';

export interface TitleProps {
    children: ReactNode;
    as?: keyof typeof HeadingTags;
    className?: string;
}

export const Title: FC<TitleProps> = ({ children, as: Component = 'h2', className, ...props }) => (
    <Component className={classNames(styles['title'], styles[Component], 'title', className)} {...props}>
        {children}
    </Component>
);
